<template>
    <div class="main">
        <c-panel title="GRUPOS POR TURMA" titleIcon="fas fa-users-cog">
            <el-alert type="info" :closable="false" class="u-mb-15"
                title="Gera os grupos das turmas conforme o critério da configuração e permite o ajuste manual de cada aluno."
                description="Regerar SUBSTITUI a divisão atual da turma — os ajustes manuais feitos antes se perdem."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Configuração" class="u-mb-0">
                            <el-select v-model="configuracaoId" filterable style="width: 100%;" @change="carregarElegiveis">
                                <el-option v-for="c in configuracoes" :key="c.id" :value="c.id"
                                    :label="c.nome + ' (' + c.qtd_grupos + ' grupos, ' + rotulo(c.criterio_divisao) + ')'"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12">
                        <el-form-item label="Filtrar por escola" class="u-mb-0">
                            <el-select v-model="instituicaoId" clearable filterable style="width: 100%;" @change="carregarElegiveis">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div v-if="configuracaoId">
                <el-row class="u-mb-10">
                    <el-col :span="24" class="u-text-right">
                        <el-button v-if="podeEscrever" type="primary" size="small" icon="el-icon-s-operation"
                            :disabled="selecionadas.length === 0" @click="gerar">
                            GERAR GRUPOS ({{ selecionadas.length }} turma{{ selecionadas.length === 1 ? '' : 's' }})
                        </el-button>
                    </el-col>
                </el-row>

                <div class="container-table">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th style="width: 50px;" class="u-text-center">
                                    <el-checkbox :value="todasMarcadas" @change="marcarTodas"></el-checkbox>
                                </th>
                                <th>Turma</th>
                                <th class="hidden-mobile">Escola</th>
                                <th style="width: 100px;" class="u-text-center">Alunos</th>
                                <th style="width: 130px;" class="u-text-center">Já dividida</th>
                                <th style="width: 110px;" class="u-text-center">Ação</th>
                            </tr>
                        </thead>
                        <tbody v-if="statusList">
                            <tr v-for="t in elegiveis" :key="t.id">
                                <td class="u-text-center">
                                    <el-checkbox :value="selecionadas.indexOf(t.id) !== -1" @change="alternar(t.id)"></el-checkbox>
                                </td>
                                <td>{{ t.nome }}</td>
                                <td class="hidden-mobile">{{ t.instituicao }}</td>
                                <td class="u-text-center">{{ t.qtd_alunos }}</td>
                                <td class="u-text-center">
                                    <el-tag v-if="t.ja_dividida" size="mini" type="success">sim</el-tag>
                                    <span v-else>—</span>
                                </td>
                                <td class="u-text-center acao">
                                    <el-button v-if="t.ja_dividida" size="mini" plain @click="abrirComposicao(t)">VER GRUPOS</el-button>
                                </td>
                            </tr>
                            <tr v-if="elegiveis.length === 0"><td colspan="6" class="u-text-center">Nenhuma turma elegível para esta configuração.</td></tr>
                        </tbody>
                    </table>
                    <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
                </div>
            </div>

            <el-alert v-else type="info" :closable="false" title="Selecione uma configuração para listar as turmas."></el-alert>

            <!-- ==================== COMPOSIÇÃO E AJUSTE MANUAL ==================== -->
            <el-dialog :title="'Grupos — ' + (turmaAtual ? turmaAtual.nome : '')" :visible.sync="dialogo" width="820px">
                <div v-if="composicao">
                    <el-alert v-if="composicao.sem_grupo && composicao.sem_grupo.length" type="warning" :closable="false" class="u-mb-15"
                        :title="composicao.sem_grupo.length + ' aluno(s) sem grupo nesta configuração.'"></el-alert>

                    <el-row :gutter="10">
                        <el-col v-for="g in composicao.grupos" :key="g.id" :xs="24" :sm="12">
                            <div class="grupo-caixa">
                                <div class="grupo-titulo">
                                    {{ g.nome }}
                                    <el-tag size="mini" :type="g.modo_padrao === 'presencial' ? 'success' : 'info'">{{ g.modo_padrao }}</el-tag>
                                    <span class="qtd">{{ g.qtd_alunos }} aluno(s)</span>
                                </div>
                                <el-select v-model="selecao[g.id]" multiple filterable style="width: 100%;"
                                    :disabled="!podeEscrever" placeholder="Alunos do grupo">
                                    <el-option v-for="a in todosAlunos" :key="a.matricula_id" :value="a.matricula_id"
                                        :label="a.aluno_nome"></el-option>
                                </el-select>
                                <el-button v-if="podeEscrever" size="mini" type="primary" plain class="u-mt-10"
                                    @click="salvarComposicao(g)">SALVAR {{ g.nome }}</el-button>
                            </div>
                        </el-col>
                    </el-row>

                    <small class="u-text-muted">
                        Um aluno pertence a UM grupo por configuração — ao salvá-lo aqui, ele sai
                        automaticamente do grupo em que estava.
                    </small>
                </div>
                <span slot="footer"><el-button @click="dialogo = false">FECHAR</el-button></span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO H — item 122: geração e ajuste manual dos grupos. */
export default {
    data: () => ({
        statusList: true, configuracaoId: null, instituicaoId: null,
        configuracoes: [], instituicoes: [], elegiveis: [], selecionadas: [],
        dialogo: false, turmaAtual: null, composicao: null, selecao: {}, todosAlunos: []
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) },
        todasMarcadas () {
            return this.elegiveis.length > 0 && this.selecionadas.length === this.elegiveis.length
        }
    },
    mounted () {
        const periodo = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : ''

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/configuracao-grupo-aluno/getAll/${periodo}`,
            this.$store.getters.getHeaderAuth
        ).then(r => {
            this.configuracoes = Array.isArray(r.data) ? r.data : []
            // Permite chegar aqui direto da listagem de configurações.
            if (this.$route.query.configuracao) {
                this.configuracaoId = parseInt(this.$route.query.configuracao)
                this.carregarElegiveis()
            }
        }).catch(e => this.$store.commit('throwException', e))

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})
    },
    methods: {
        rotulo (v) {
            return { alfabetico: 'alfabética', numero_chamada: 'nº de chamada',
                manual: 'manual', aleatorio: 'sorteio' }[v] || v
        },
        carregarElegiveis () {
            this.elegiveis = []; this.selecionadas = []
            if (!this.configuracaoId) return

            this.statusList = false
            const base = `${this.$store.state.config.baseUrlApi}/api/configuracao-grupo-aluno/turmasElegiveis/${this.configuracaoId}`
            const url = this.instituicaoId ? `${base}/${this.instituicaoId}` : base

            this.$axios.get(url, this.$store.getters.getHeaderAuth).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    this.statusList = true
                    return
                }
                this.elegiveis = r.data.itens || []
                this.statusList = true
            }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },
        alternar (id) {
            const i = this.selecionadas.indexOf(id)
            if (i === -1) this.selecionadas.push(id)
            else this.selecionadas.splice(i, 1)
        },
        marcarTodas (marcar) {
            this.selecionadas = marcar ? this.elegiveis.map(t => t.id) : []
        },
        gerar () {
            const jaDivididas = this.elegiveis.filter(t => this.selecionadas.indexOf(t.id) !== -1 && t.ja_dividida)

            const confirmar = jaDivididas.length
                ? this.$confirm(`${jaDivididas.length} turma(s) já têm grupos gerados. Regerar substitui a divisão atual e desfaz os ajustes manuais. Continuar?`,
                    'Confirmação', { confirmButtonText: 'Regerar', cancelButtonText: 'Cancelar', type: 'warning' })
                : Promise.resolve()

            confirmar.then(() => {
                window.eventBus.$emit('loading', true)
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/grupo-aluno/gerarGrupos`,
                    { configuracao_grupo_aluno_id: this.configuracaoId, turma_ids: this.selecionadas },
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }

                    const comErro = (r.data.resultados || []).filter(x => x.erro)
                    let msg = r.data.mensagem
                    if (comErro.length) msg += ` ${comErro.length} turma(s) não puderam ser divididas.`

                    window.eventBus.$emit('alert', { msg: msg, type: comErro.length ? 'warning' : 'success' })
                    this.carregarElegiveis()
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            }).catch(() => {})
        },
        abrirComposicao (t) {
            this.turmaAtual = t
            this.composicao = null
            this.selecao = {}
            this.todosAlunos = []
            this.dialogo = true

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/grupo-aluno/getByTurma/${t.id}/${this.configuracaoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }

                this.composicao = r.data

                const alunos = []
                r.data.grupos.forEach(g => {
                    this.$set(this.selecao, g.id, g.alunos.map(a => a.matricula_id))
                    g.alunos.forEach(a => alunos.push(a))
                })
                ;(r.data.sem_grupo || []).forEach(a => alunos.push({ matricula_id: a.id, aluno_nome: a.aluno_nome }))

                this.todosAlunos = alunos.sort((a, b) => a.aluno_nome.localeCompare(b.aluno_nome))
            }).catch(e => this.$store.commit('throwException', e))
        },
        salvarComposicao (g) {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/grupo-aluno/salvarComposicao/${g.id}`,
                { matricula_ids: this.selecao[g.id] || [] }, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                this.abrirComposicao(this.turmaAtual)
            }).catch(e => this.$store.commit('throwException', e))
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.grupo-caixa { border: 1px solid #dcdfe6; border-radius: 4px; padding: 10px; margin-bottom: 12px; }
.grupo-titulo { font-weight: bold; margin-bottom: 8px; }
.grupo-titulo .qtd { float: right; font-weight: normal; font-size: 12px; color: #909399; }
</style>
